import axios from 'axios';
import camelCaseObject from './camelCaseObject';
// TODO: commenting these retry bits out for now; will bring it back once we have stream retries
// again
// import setupRetry from './setupRetry';

// let retryLimit;
let timeout;

export function setup(timeoutConfig) {
  // retryLimit = retryLimitConfig;
  timeout = timeoutConfig;
}

export function unwrapStream(url) {
  const now = Date.now();

  return axios({
    url,
    transformResponse: [...axios.defaults.transformResponse, camelCaseObject],
    timeout,
  }).catch((err) => {
    err.errorData = {
      duration: Date.now() - now,
    };

    throw err;
  });

  // return setupRetry(unwrapCallback, retryLimit);
}
